import BreadcrumbValueObjectsFactory from '../ValueObjects/factory.js'
import BreadcrumbProxyMapper from './BreadcrumbProxyMapper.js'
import FromEmptyPageNameToDefaultBreadcrumbVOMapper from './FromEmptyPageNameToDefaultBreadcrumbVOMapper.js'
import {FromNewsDetailInfoToBreadcrumbRequestValueObjectMapper} from './FromNewsDetailInfoToBreadcrumbRequestValueObjectMapper.js'
import FromPageNameToAdsListBreadcrumbVOMapper from './FromPageNameToAdsListBreadcrumbVOMapper.js'
import {FromPageNameToLandingsBreadcrumbVOMapper} from './FromPageNameToLandingsBreadcrumbVOMapper.js'
import {FromPageNameToModelDetailBreadcrumbVOMapper} from './FromPageNameToModelDetailBreadcrumbVOMapper.js'
import FromPageNameToNewsBreadcrumbVOMapper from './FromPageNameToNewsBreadcrumbVOMapper.js'
import FromPageNameToTechnicalDetailsBreadcrumbVOMapper from './FromPageNameToTechnicalDetailsBreadcrumbVOMapper.js'
import {FromRawBreadcrumbResponseToDetailBreadcrumbVOMapper} from './FromRawBreadcrumbResponseToDetailBreadcrumbVOMapper.js'
import {FromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper} from './FromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper.js'

export default class BreadcrumbMappersFactory {
  static breadcrumbProxyMapper = ({config}) =>
    new BreadcrumbProxyMapper({
      config,
      valueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject,
      fromEmptyPageNameToDefaultBreadcrumbVOMapper:
        BreadcrumbMappersFactory.fromEmptyPageNameToDefaultBreadcrumbVOMapper({
          config
        }),
      fromPageNameToNewsBreadcrumbVOMapper: BreadcrumbMappersFactory.fromPageNameToNewsBreadcrumbVOMapper({
        config
      }),
      fromPageNameToTechnicalDetailsBreadcrumbVOMapper:
        BreadcrumbMappersFactory.fromPageNameToTechnicalDetailsBreadcrumbVOMapper({config}),
      fromPageNameToAdsListBreadcrumbVOMapper: BreadcrumbMappersFactory.fromPageNameToAdsListBreadcrumbVOMapper({
        config
      }),
      fromPageNameToLandingsBreadcrumbVOMapper: BreadcrumbMappersFactory.fromPageNameToLandingsBreadcrumbVOMapper({
        config
      }),
      fromPageNameToModelDetailBreadcrumbVOMapper: BreadcrumbMappersFactory.fromPageNameToModelDetailBreadcrumbVOMapper(
        {
          config
        }
      )
    })

  static fromEmptyPageNameToDefaultBreadcrumbVOMapper = ({config}) =>
    new FromEmptyPageNameToDefaultBreadcrumbVOMapper({
      config,
      valueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromPageNameToNewsBreadcrumbVOMapper = ({config}) =>
    new FromPageNameToNewsBreadcrumbVOMapper({
      config,
      valueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromPageNameToTechnicalDetailsBreadcrumbVOMapper = ({config}) =>
    new FromPageNameToTechnicalDetailsBreadcrumbVOMapper({
      config,
      valueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromPageNameToAdsListBreadcrumbVOMapper = ({config}) =>
    new FromPageNameToAdsListBreadcrumbVOMapper({
      config,
      valueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromPageNameToLandingsBreadcrumbVOMapper = ({config}) =>
    new FromPageNameToLandingsBreadcrumbVOMapper({
      config,
      breadcrumbValueObjectFactory: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromPageNameToModelDetailBreadcrumbVOMapper = ({config}) =>
    new FromPageNameToModelDetailBreadcrumbVOMapper({
      config,
      breadcrumbValueObjectFactory: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper = ({config}) =>
    new FromRawBreadcrumbResponseToDetailBreadcrumbVOMapper({
      config,
      breadcrumbValueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper = ({config}) =>
    new FromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper({
      config,
      breadcrumbValueObject: BreadcrumbValueObjectsFactory.breadcrumbValueObject
    })

  static fromNewsDetailInfoToBreadcrumbRequestValueObjectMapper = () =>
    new FromNewsDetailInfoToBreadcrumbRequestValueObjectMapper({
      breadcrumbUrlBuilderRequestValueObject: BreadcrumbValueObjectsFactory.breadcrumbUrlBuilderRequestValueObject
    })
}
